<template>
  <div class="material-limits-handbook">
    <q-linear-progress v-if="isProjectTypesLoading" indeterminate class="tw-mb-4" />
    <div v-else class="tw-pt-4">
      <TabsWithDrawer
        :tabs="tabs"
        :default-tab="defaultTab"
        drawer-title="Конструктивы"
        page-title="Лимиты материалов по конструктиву"
        :drawer-width="'280px'"
        :show-header="true"
        @tab-changed="onTabChanged"
      />
    </div>
  </div>
</template>

<script setup>
import TabsWithDrawer from "@/components/common/TabsWithDrawer.vue";
import { useQuery } from "@tanstack/vue-query";
import { computed } from "vue";
import { useRoute, useRouter } from "vue-router";
import MaterialLimitsTable from "./MaterialLimitsTable.vue";
import { getProjectTypes } from "./services";

const route = useRoute();
const router = useRouter();

const { data: projectTypesData, isLoading: isProjectTypesLoading } = useQuery({
  queryKey: ["projectTypesMaterialLimits"],
  queryFn: getProjectTypes,
  refetchOnWindowFocus: false,
});

const tabs = computed(() => {
  const types = projectTypesData.value || [];
  return types.map((t) => ({
    key: `project-type-${t.project_type_id}`,
    label: t.project_type_name,
    component: MaterialLimitsTable,
    props: {
      projectTypeId: t.project_type_id,
      title: `Лимиты материалов: ${t.project_type_name}`,
    },
  }));
});

const defaultTab = computed(() => {
  if (route.query.projectTypeId) {
    const id = Number(route.query.projectTypeId);
    const tabKey = `project-type-${id}`;
    const exists = tabs.value.some((tab) => tab.key === tabKey);
    if (exists) return tabKey;
  }
  const first = tabs.value[0];
  return first ? first.key : null;
});

function onTabChanged(tabKey) {
  const projectTypeId = tabKey
    ? Number(tabKey.replace("project-type-", ""))
    : null;
  router
    .push({
      name: "handbook",
      params: { type: "material-limits" },
      query: { projectTypeId: projectTypeId || undefined },
    })
    .catch(() => {});
}
</script>

<style lang="scss" scoped>
.material-limits-handbook {
  min-height: 400px;
}
</style>
